import { render, staticRenderFns } from "./myMediation.vue?vue&type=template&id=08af3178&scoped=true&"
import script from "./myMediation.vue?vue&type=script&lang=js&"
export * from "./myMediation.vue?vue&type=script&lang=js&"
import style0 from "./myMediation.vue?vue&type=style&index=0&id=08af3178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af3178",
  null
  
)

export default component.exports